<div class="pull-right margin-botton-small">
    <button class="card-inline " (click)="addNew()" type="button" mat-mini-fab>
    <mat-icon>add</mat-icon>
</button>
</div>
<table class="search-table" mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="CompanyName">
        <th class="search-table-header" mat-header-cell *matHeaderCellDef>
            Empresa
        </th>
        <td class="search-table-cell" mat-cell *matCellDef="let element">
            <div>{{element.CompanyName }}</div>
        </td>
    </ng-container>
    <ng-container matColumnDef="ServiceName">
        <th class="search-table-header" mat-header-cell *matHeaderCellDef>
            Servicio
        </th>
        <td class="search-table-cell" mat-cell *matCellDef="let element">
            <div>{{ element.ServiceName }}</div>
        </td>
    </ng-container>
    <ng-container matColumnDef="Amount">
        <th class="search-table-header" mat-header-cell *matHeaderCellDef>
            Importe
        </th>
        <td class="search-table-cell" mat-cell *matCellDef="let element">
            <div>{{ element.Amount }}</div>
        </td>
    </ng-container>

    <ng-container matColumnDef="AliquotTax">
        <th class="search-table-header" mat-header-cell *matHeaderCellDef>
            Alícuota
        </th>
        <td class="search-table-cell" mat-cell *matCellDef="let element">
            <div>{{ element.AliquotTax.Percentage }}</div>
        </td>
    </ng-container>

    <ng-container matColumnDef="Edit">
        <th mat-header-cell *matHeaderCellDef>

        </th>
        <td class="search-table-cell" mat-cell *matCellDef="let element; let i = index">
            <button type="button" (click)="editItem( element )" mat-icon-button><mat-icon>edit</mat-icon></button>
        </td>
    </ng-container>

    <ng-container matColumnDef="Delete">
        <th mat-header-cell *matHeaderCellDef>

        </th>
        <td class="search-table-cell" mat-cell *matCellDef="let element; let i = index">
            <button *ngIf="!noDeleteItem" type="button" (click)="deleteItem( i )" mat-icon-button><mat-icon>delete</mat-icon></button>
        </td>
    </ng-container>


    <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayedColumns;"></tr>
</table>